export default {
  title: 'Account Transfers reports',
  tableHeaderActionTooltip: 'Create new Account Transfers report',
  dialog: {
    title: {
      generateReport: 'Generate Account Transfers report',
      deleteReport: 'Delete Account Transfers report',
      cancelReport: 'Cancel Account Transfers report',
      regenerateReport: 'Regenerate Account Transfers report',
      retryReport: 'Retry Account Transfers report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate Account Transfers report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Name',
    placeholder: 'Enter Account Transfers report name'
  },
  table: {
    emptyMsg: "You don't have any Account Transfers reports to display"
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
